import { USER_DOMAIN } from '@/shared/constants/user-domain.constant';

export const APP_PREFIX = {
	[USER_DOMAIN.YACHTING]: '/yachting',
	[USER_DOMAIN.INDUSTRIAL]: '/industrial',
	[USER_DOMAIN.RESIDENTIAL]: '/residential',
} as const;
